import { SingleSubject } from './SingleSubject';
export default SingleSubject;
